import { c as _c } from "react/compiler-runtime";
import { LINKS } from '@/constants/links';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Articles from '../Articles';
import { ArticleBoxProps } from '@/components/boxes';
function PressReleases(t0) {
  const $ = _c(12);
  const {
    pressReleasesArticles
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["forJournalists"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("pressReleasesSection.button");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = LINKS();
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = {
      analyticsParam: "pressReleasesSectionViewAll",
      label: t2,
      link: t3.pressReleases,
      testId: "pressReleasesSectionViewAll"
    };
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t) {
    t5 = t("pressReleasesSection.title");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== pressReleasesArticles || $[9] !== t4 || $[10] !== t5) {
    t6 = <Articles articles={pressReleasesArticles} button={t4} title={t5} />;
    $[8] = pressReleasesArticles;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
export default PressReleases;